module.exports = __webpack_public_path__ + "img/empanadillas.efb6a504.jpeg";